import(/* webpackMode: "eager" */ "/app/node_modules/next/font/local/target.css?{\"path\":\"src/app/fonts.ts\",\"import\":\"\",\"arguments\":[{\"src\":[{\"path\":\"../../public/assets/fonts/Inter-VariableFont_opsz,wght.ttf\",\"style\":\"normal\"}],\"variable\":\"--inter\"}],\"variableName\":\"inter\"}");
;
import(/* webpackMode: "eager", webpackExports: ["ClientProviders"] */ "/app/src/components/ClientProviders/ClientProviders.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/Layouts/AdminLayout/AdminLayout.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/Layouts/AuthLayout/AuthLayout.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/Layouts/AuthLayout/styles/AuthLayout.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/Layouts/GridLayout/GridLayout.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/Layouts/MainLayout/MainLayout.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/Layouts/MainLayout/styles/MainLayout.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/TranslationsProvider/TranslationsProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/lib/registry.tsx");
